export function SITE_BANNER_HEIGHT(user) {
  // New Build 3 (Sep 18 2026): the site-wide gold banner is gone — only the impersonation
  // banner still pushes content down. Second param kept optional for callers that still pass it.
  return user?._impersonating ? 36 : 0;
}
